import Vue from 'vue';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask';
import Loading from 'vue-loading-overlay';
//import 'vue-loading-overlay/dist/vue-loading.css';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import moment from 'moment';
import 'moment/locale/nb'  // without this line it didn't work
moment.locale('nb')

Vue.use(VeeValidate, {
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});

Vue.use(VueCookies)
Vue.use(Loading);
Vue.use(VueMask);
Vue.use(BootstrapVue);

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(value).format('DD. MMM');
    }

    return '???'
});

const minDate = moment("0001-01-01");

var app = new Vue({
    el: '#blakveiteQuota',
    components: {
        PulseLoader
    },

    data: {
        periodOne: {
            Start: null,
            End: null,
            Ships: 0,
            Target: 0,
            Catch: 0
        },
        periodTwo: {
            Start: null,
            End: null,
            Ships: 0,
            Target: 0,
            Catch: 0
        },

        dbData: null
    },

    watch: {
        'periodOne.Start': function (val) {
            this.tryLoadQuotas();
        },

        dbData: function (val) {
            if (val) {
                this.periodOne.Ships = val[0].Ships || 0;
                this.periodOne.Catch = val[0].Weight || 0;
                this.periodTwo.Ships = val[1] ? val[1].Ships || 0 : 0;
                this.periodTwo.Catch = val[1] ? val[1].Weight || 0 : 0;
            }
        },
    },

    computed: {
        activePeriod: function () {
            if (this.periodOne.Start && this.periodTwo.Start) {
                return moment() >= this.periodTwo.Start ? this.periodTwo : this.periodOne;
            }
            return this.periodOne;
        },

        columnWidth: function () {
            if (this.periodOne.Target && this.periodTwo.Target) {
                var columnOneWidth = Math.floor(this.periodOne.Target * 100 / (this.periodOne.Target + this.periodTwo.Target)) 
                var columnTwoWidth = 100 - columnOneWidth

                return columnOneWidth + '%' + ' ' + columnTwoWidth + '%'
            }
            return '50% 50%';
        },

        periodOneProcent: function () {
            if (this.periodOne.Target && this.periodOne.Catch) {
                return Math.floor(this.periodOne.Catch * 100 / this.periodOne.Target) + '%'
            }
            return '0%';
        },

        periodTwoProcent: function () {
            if (this.periodTwo.Target && this.periodTwo.Catch) {
                return Math.floor(this.periodTwo.Catch * 100 / this.periodTwo.Target) + '%'
            }
            return '0%';
        },

        isDataLoading: function () {
            return this.dbData === null;
        },
    },

    methods: {
        getQuotas: function () {
            var self = this;
            axios.get('/umbraco/Surface/Statistic/GetQuotas', { params: { periodOne: self.periodOne.Start._i, periodTwo: self.periodTwo.Start._i } })
                .then((response) => {
                    if (response.data !== 'error') {
                        self.dbData = response.data;
                        self.saveQuotas();
                    }
                    else {
                        self.dbData = [];
                    }
                })
                .catch(function (error) {
                    self.dbData = [];
                    console.log(error);
                });
        },

        readPeriodValues: function () {
            var self = this;
            self.periodOne.Start = moment(self.$refs.periodOneStart.innerHTML, "YYYY-MM-DD");
            self.periodTwo.Start = moment(self.$refs.periodTwoStart.innerHTML, "YYYY-MM-DD");
            self.periodOne.End = moment(self.$refs.periodOneEnd.innerHTML, "YYYY-MM-DD").isAfter(minDate) ? moment(self.$refs.periodOneEnd.innerHTML, "YYYY-MM-DD") : self.periodTwo.Start;
            self.periodTwo.End = moment(self.$refs.periodTwoEnd.innerHTML, "YYYY-MM-DD").isAfter(minDate) ? moment(self.$refs.periodTwoEnd.innerHTML, "YYYY-MM-DD") : null;
            self.periodOne.Target = ~~self.$refs.periodOneQuota.innerHTML;
            self.periodTwo.Target = ~~self.$refs.periodTwoQuota.innerHTML;
        },

        makeToast(title, body, variant) {
            this.$bvToast.toast(body, {
                title: title,
                variant: variant,
                solid: true
            });
        },

        saveQuotas: function () {
            try {
                var self = this;
                var quotas = self.dbData.map(quota => ({ Period: quota.Period, Ships: quota.Ships, Weight: quota.Weight }));
                self.$cookies.set('_rflBKQuotas', JSON.stringify(quotas), "5min");

            } catch (e) {
                console.log('error saving quotas cookie');
            }
        },

        tryLoadQuotas: function () {
            var self = this;
            try {
                var quotas = self.$cookies.get("_rflBKQuotas");
                if (quotas && quotas !== null) {
                    quotas = $.parseJSON(quotas);
                    self.dbData = quotas;
                }
                else {
                    this.getQuotas();
                }

            } catch (e) {
                this.getQuotas();
                console.log('error reading quotas cookie');
            }
        },
    },

    mounted() {
        this.readPeriodValues();
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/blakveiteQuota/index.js